import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Empty } from "@/components/common";
import { fmtDT } from "@/lib/format";

const TONE = { attiva: "bg-sky-100 text-sky-800", risolta: "bg-emerald-100 text-emerald-800", interrotta: "bg-zinc-200 text-zinc-700" };
const STAGE = ["Solleciti agli incaricati", "Solleciti agli incaricati", "Escalation al responsabile", "Escalation al CEO"];

export const TakeoversPanel = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/toth/takeovers").then((r) => setRows(r.data));
  }, []);
  if (!rows) return <p className="text-muted-foreground">Caricamento…</p>;
  if (!rows.length) return <Empty text="Nessuna pratica affidata a Toth. Usa «Affida a Toth» nel dettaglio di un ordine o di una criticità." testid="takeovers-empty" />;
  return (
    <div className="space-y-3" data-testid="takeovers-list">
      {rows.map((t) => (
        <Link key={t.id} to={`/${t.target.type === "work_order" ? "ordini" : "criticita"}/${t.target.id}`} className="card-soft block p-5 hover:bg-accent/30" data-testid={`takeover-${t.id}`}>
          <div className="flex flex-wrap items-center gap-2">
            <p className="min-w-0 flex-1 font-bold">{t.target.code} · {t.target.title}</p>
            <span className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${TONE[t.status]}`}>{t.status}</span>
          </div>
          <p className="mt-1 text-xs text-muted-foreground">Dal {fmtDT(t.started_at)} · {t.status === "attiva" ? STAGE[t.stage] : `terminata ${fmtDT(t.ended_at)}`} · {t.reminders} solleciti · ultimo: {t.history[t.history.length - 1]?.text}</p>
        </Link>
      ))}
    </div>
  );
};
